import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import styled from 'styled-components'
import Home from './routes/Home'
import SupabaseMatch from './routes/SupabaseMatch'
import Admin from './routes/Admin'
import TopMenu from './components/TopMenu.js'
import * as Settings from './components/Settings.js'

const PaddingWrapper = styled.div`
    display: block;
    max-width: 1240px;
    margin: 0 auto;
`

const Wrapper = styled.div`
    display: grid;
    grid-template-rows: 7.5rem 1fr;
    grid-row-gap: 10px;
    margin: 0 20px;
`

const MainContainer = styled.div`
    grid-row: 2;
`

const RouteWithTopMenu = ({ component: Component, ...rest }) =>
    <Route
        {...rest}
        render={props => [
            <TopMenu key="topMenu" {...props} />,
            <MainContainer className="container" key="mainContainer" id="MainContainer">
                <Component key="Component" {...props} />
            </MainContainer>,
        ]}
    />

class App extends React.Component {
    state = {}

    render() {
        return (
            <Settings.Context.Provider value={this.state}>
                <BrowserRouter>
                    <PaddingWrapper>
                        <Wrapper>
                            <Switch>
                                <RouteWithTopMenu path="/" exact component={Home} />
                                <RouteWithTopMenu path="/admin" exact component={Admin} />
                                <RouteWithTopMenu path="/match/:matchId" component={SupabaseMatch} />
                            </Switch>
                        </Wrapper>
                    </PaddingWrapper>
                </BrowserRouter>
            </Settings.Context.Provider>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/routes.js